import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { Client } from './client';

export class ProductType extends BaseClass implements BaseRepository {
    name: string;
    client: Client;
    minimum: number;
    maximum: number;

    constructor()
    constructor(
      name: string, client: Client, minimum: number, maximum: number)
    constructor(
      name?: string, client?: Client, minimum?: number, maximum?: number) {
        super();

        this.name = this.trim(name);
        this.client = client || null;
        this.minimum = minimum;
        this.maximum = maximum;
    }

    static fromObject(object: ProductType): ProductType {
        return Object.assign(new ProductType(), {
          ...object,
            client: object.client ? Client.fromObject(object.client) : null
        });
    }

    get display(): string {
        return `${this.name}`;
    }

    doesInclude(value: string): boolean {
        return this.some([this.name], value);
    }
}
